import { z } from "zod";

/**
 * The custom apps the caller can access. App names are intentionally open-ended
 * strings: a newly registered app must never fail parsing for clients that
 * don't know about it yet.
 */
export const AppRegistrySchema = z.object({
  apps: z.array(z.string()),
});

export type AppRegistryType = z.infer<typeof AppRegistrySchema>;
